import { Box, Stack, useTheme } from '@mui/material'
import { grey } from '@mui/material/colors'
import { makeStyles } from '@mui/styles'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Catalog from '../../../../../../api/db/Catalog'
import pubsub from '../../../../../../modules/pubsub'
import { IInventoryItemCateogry } from '../../../../../../shared/types'
import { selectCurrrentAdminShop } from '../../../../../../store/features/currentBusinessShop'
import { selectUserPropsState } from '../../../../../../store/features/user'
import BodySkeleton from '../../../../common/skeletons/BodySkeleton'
import Table from '../Table'

export default function ContentBody() {

    const [loading, setLoading] = useState(true)
    const user_id = useSelector(selectUserPropsState)?.uid
    const current_shop = useSelector(selectCurrrentAdminShop)?.name
    const [productCategories, setProductCategories] = useState<IInventoryItemCateogry[]>([])
    const theme = useTheme()

    useEffect(()=>{

        pubsub.on("category-list:changed", getProductCategories)

        getProductCategories()

        return ()=>pubsub.off("category-list:changed", getProductCategories)
    
    // eslint-disable-next-line
    },[])

    const useStyles = makeStyles({
        content:{
            flex: 1, 
            border: `.5px solid rgba(255, 255, 255, 0.1)`,
            borderRadius: "4px", 
            minHeight: "420px", 
            backgroundColor: theme.palette.primary.main,
            padding: "1rem"
        },
        searchField:{
            backgroundColor: theme.palette.primary.dark,
            border: `.5px solid rgba(255, 255, 255, 0.1)`,
            padding: ".3rem",
            borderRadius: "3px",
            color: grey[200],
            fontWeight: "regular",
            fontSize: "14px",
            outline: "none"
        }
    })

    const classes = useStyles()

    const getProductCategories = async ()=>{
        
        try {
            
            setLoading(true)
            const res = await Catalog.getCategories(user_id, current_shop)
            setProductCategories(res)
            setLoading(false )
            
        } catch (error) {
            setLoading(false )
            throw error
        }
        
    }
    
    return (
        <>
            {
                loading ? (
                    <BodySkeleton />
                ):(
                    <Box className={classes.content} >

                        <Stack
                            sx={{height: "100%"}}
                            direction="column"
                            spacing={2}
                        >

                            <Table 
                                title="Categories catalog"
                                tableBodyData={productCategories}
                                tableHeadData={["Date", "Name", "Gross revenue", "Gross profit"]}
                                handleItemClick={()=>{}}
                            />

                        </Stack>

                        
                    </Box>
                )
            }
        </>
    )
}
